import { PhoneFilled } from '@ant-design/icons';
import { Badge, Button, Divider, Space } from 'antd';
import { useStopwatch } from 'react-timer-hook';
import { twoDigitNumber } from '../../utils/helpers';
import { onlineColor } from './CallApp';

interface AnsweredCallButtonProps {
    togglePopover: () => void;
}

const CallCountButton = ({ togglePopover }: AnsweredCallButtonProps): JSX.Element => {
    const { seconds, minutes, hours, days } = useStopwatch({ autoStart: true });

    return (
        <Button style={{ backgroundColor: 'transparent' }} onClick={togglePopover}>
            <Space align="center">
                <Badge dot style={{ marginTop: 6, marginLeft: -9, width: 8, minWidth: 8, height: 8 }} />
                <div>
                    {days > 0 && (
                        <>
                            <span>{twoDigitNumber(hours)}</span>:
                        </>
                    )}
                    <span>{twoDigitNumber(minutes)}</span>:<span>{twoDigitNumber(seconds)}</span>
                </div>
                <Divider type="vertical" />
                <PhoneFilled style={{ color: onlineColor }} />
            </Space>
        </Button>
    );
};

export default CallCountButton;
